<template>
  <div class="op-list-item" @click="onDutySelected()">
    <div class="op-left">
      <v-icon v-text="thisDutyActivities.length > 0 ? 'mdi-timetable' : 'mdi-message-bulleted'">{{}}></v-icon>
    </div>

    <div class="op-content">
      <div class="op-content-title">{{ mx_getDutyDate(duty) }}</div>
      <div class="op-content-inner">
        <div>{{ $t('myDuty.title') }} {{ duty.dutyname }}</div>
        <duty-card-content :class="xs ? '' : 'chips'" :show-date="false" :duty="duty" height="3.8em"></duty-card-content>
      </div>
    </div>
  </div>
</template>

<script>
import dutyMixin from '../common/dutyMixin';
import commonMixin from '@/mixins/common';
import MODULE_ID from '../moduleId';
import { mapState } from 'vuex';
import tenantStrategies from '../dutyActivities/tenantStrategies';
import DutyCardContent from './DutyCardContent.vue';

export default {
  name: 'DutyListItem',
  mixins: [dutyMixin, commonMixin],
  components: {
    DutyCardContent,
  },
  props: {
    duty: Object,
  },

  methods: {
    onDutySelected() {
      this.$router.push(`/myduties/detail/${this.duty.id}`);
    },
  },
  computed: {
    ...mapState(MODULE_ID, ['dutyActivities', 'dutyStops']),
    ...mapState({ tenant: (state) => state.profile.customerRelations.tenant }),
    thisDutyActivities() {
      return this.mx_getDutyActivities(this.duty, { tenant: this.tenant });
    },
    /**
     * Get first activity whose blockcode is not null
     */
    firstActivity() {
      return tenantStrategies.getFirstActivity({ moduleConfig: this.mx_moduleConfig, tenant: this.tenant, dutyActivities: this.thisDutyActivities });
    },
    lastActivity() {
      return tenantStrategies.getLastActivity({ moduleConfig: this.mx_moduleConfig, tenant: this.tenant, dutyActivities: this.thisDutyActivities });
    },
    locationFromTo() {
      const da = this.thisDutyActivities;
      if (da && da.length > 0) {
        let start = this.firstActivity && this.firstActivity._startStop ? this.firstActivity._startStop.shortname : '';
        let lastDa = this.lastActivity;
        let end = lastDa._endStop ? lastDa._endStop.shortname : '';

        return end && start ? `${start} - ${end}` : null;
      }
      return null;
    },
    dutyTime() {
      let time = '';
      if (this.firstActivity && this.firstActivity.fromMinutesAfterMidnight)
        time += this.mx_time(this.firstActivity.fromMinutesAfterMidnight, this.firstActivity) + ' - ';
      if (this.lastActivity && this.lastActivity.toMinutesAfterMidnight) time += this.mx_time(this.lastActivity.toMinutesAfterMidnight, this.lastActivity);
      return time;
    },
    vehicleLocation() {
      let rows = this.thisDutyActivities
        .filter((da) => da.fzgStandplatz || da.fzgStandplatz)
        .map((da) => `${da.fzgStandplatz}${da.fzgNummer ? ' / ' + da.fzgNummer : ''}`);
      return rows;
    },

    /** Might be not exactly precise */
    dutyDetails() {
      let duty = this.duty;
      if (duty._dutyActivities) {
        for (let i = 0; i < duty._dutyActivities.length; i++) {
          let dutyActivity = duty._dutyActivities[i];
          if (!isNaN(dutyActivity.blockcode) && dutyActivity.line) {
            let hasTracks =
              this.$store.getters['meinDienst/getDutyTracks']({
                dutyDateIsoString: duty.day,
                dutyStartMinutesAfterMidnight: duty._startMinutesAfterMidnight,
                dutyEndMinutesAfterMidnight: duty._endMinutesAfterMidnight,
                line: dutyActivity.line,
                track: dutyActivity.blockcode,
              }).length > 0;
            // console.debug('hasTracks,dutyActivity.blockcode) && dutyActivity.line', hasTracks, dutyActivity.blockcode, dutyActivity.line);
            return { hasTracks, track: dutyActivity.blockcode, line: dutyActivity.line };
          }
        }
      }
      return null;
    },
  },
};
</script>
<style scoped>
.chips {
  position: absolute;
  left: 200px;
  top: 10px;
  bottom: 10px;

  display: flex;
  flex-direction: row;
}
.chips-xs {
  position: absolute;
  left: 30px;

  bottom: 5px;

  display: flex;
  flex-direction: row;
}
</style>
